import $ from 'jquery';
import Texter from "../texter.es6";
import Modaller from "./../modaller";

require('jsrender')($);

const TEMPLATE = $.templates(`
<div class="fl-learn-tune-form">
    <div class="fl-learn-tune-form__label">{{>~l18n.get('packLearn.dialogs.options.questionTitle')}}</div>
    <div class="fl-learn-tune-form__content">
        <div class="custom-control custom-checkbox custom-control-inline">
            <input id="packLearnTune_qTerm" type="checkbox" name="qTerm" class="custom-control-input" autocomplete="off">
            <label for="packLearnTune_qTerm" class="custom-control-label">{{>~l18n.get('packLearn.dialogs.options.questionTerm')}}</label>
        </div>    
        <div class="custom-control custom-checkbox custom-control-inline">
            <input id="packLearnTune_qDefinition" type="checkbox" name="qDefinition" class="custom-control-input" autocomplete="off">
            <label for="packLearnTune_qDefinition" class="custom-control-label">{{>~l18n.get('packLearn.dialogs.options.questionDefinition')}}</label>
        </div>    
    </div>
    <div class="fl-learn-tune-form__error" data-bind="questionError" style="display: none;">
            {{>~l18n.get('packLearn.dialogs.options.questionError')}}
    </div>
</div>
<div class="fl-learn-tune-form">
    <div class="fl-learn-tune-form__label">{{>~l18n.get('packLearn.dialogs.options.modeTitle')}}</div>
    <div class="fl-learn-tune-form__content">
        <div class="custom-control custom-checkbox custom-control-inline">
            <input id="packLearnTune_mSelect" type="checkbox" name="mSelect" class="custom-control-input" autocomplete="off">
            <label for="packLearnTune_mSelect" class="custom-control-label">{{>~l18n.get('packLearn.dialogs.options.modeSelect')}}</label>
        </div>    
        <div class="custom-control custom-checkbox custom-control-inline">
            <input id="packLearnTune_mWrite" type="checkbox" name="mWrite" class="custom-control-input" autocomplete="off">
            <label for="packLearnTune_mWrite" class="custom-control-label">{{>~l18n.get('packLearn.dialogs.options.modeWrite')}}</label>
        </div>    
    </div>
    <div class="fl-learn-tune-form__error" data-bind="modeError" style="display: none;">
        {{>~l18n.get('packLearn.dialogs.options.modeError')}}
    </div>
</div>
<div class="fl-learn-tune-form">
    <div class="fl-learn-tune-form__label">{{>~l18n.get('packLearn.dialogs.options.modeRandom')}}</div>
    <div class="fl-learn-tune-form__content">
        <div class="custom-control custom-switch custom-control-inline">
            <input id="packLearnTune_random" name="rand" type="checkbox" class="custom-control-input" autocomplete="off" {{if config.rand}}checked{{/if}}>
            <label class="custom-control-label" for="packLearnTune_random"></label>
        </div>
    </div>
</div>
<div class="fl-learn-tune-form">
    <div class="fl-learn-tune-form__label">{{>~l18n.get('packLearn.dialogs.options.playAudio')}}</div>
    <div class="fl-learn-tune-form__content">
        <div class="custom-control custom-switch custom-control-inline">
            <input id="packLearnTune_playAudio" name="playAudio" type="checkbox" class="custom-control-input" autocomplete="off" {{if config.playAudio}}checked{{/if}}>
            <label class="custom-control-label" for="packLearnTune_playAudio"></label>
        </div>
    </div>
</div>
<div class="fl-learn-tune-form">
    <div class="fl-learn-tune-form__label">{{>~l18n.get('packLearn.dialogs.options.resetTitle')}}</div>
    <div class="fl-learn-tune-form__content">
        <button class="btn btn-outline-primary btn-sm" data-click="resetProgress">{{>~l18n.get('packLearn.dialogs.options.resetButton')}}</button>    
    </div>
</div>
`);

export default class PackLearnTune {
    constructor(opts) {
        this.l18n = Texter.create(opts.l18n);
        this.ok = false;
        this.callback = opts.callback || $.noop;
        this.clearProgress = opts.clearProgress || $.noop;
        this.config = opts.config || {};
    }

    execute() {
        Modaller.showLocal(TEMPLATE.render(this, this), modaller => {
            this.modaller = modaller;
            this._show();
        });
    }

    _show() {
        this.modaller.setTitle(this.l18n.get('packLearn.dialogs.options.title'));
        this.saveButton = this.modaller.addFooterButton(this.l18n.get('button.save'), 'btn btn-primary', () => {
            this.ok = true;
            this.complete();
        });
        this.modaller.addFooterButton(this.l18n.get('button.cancel'), 'btn btn-light', () => {
            this.complete();
        });


        this.getFormInput('qTerm').prop('checked', !!this.getConfigValue('qTerm'));
        this.getFormInput('qDefinition').prop('checked', !!this.getConfigValue('qDefinition'));
        this.getFormInput('mSelect').prop('checked', !!this.getConfigValue('mSelect'));
        this.getFormInput('mWrite').prop('checked', !!this.getConfigValue('mWrite'));
        this.getFormInput('rand').prop('checked', !!this.getConfigValue('rand'));
        this.getFormInput('playAudio').prop('checked', !!this.getConfigValue('playAudio'));
        this.modaller.content.find('button[data-click=resetProgress]').click(() => {
            this.clearProgress();
        });

        this.modaller.content.find('input').change(() => {
            this.validateForm();
            return true;
        });

        this.validateForm();
    }

    getConfigValue(name) {
        return name in this.config ? this.config[name] : null;
    }

    getFormInput(name) {
        return this.modaller.content.find(`input[name=${name}]`);
    }

    validateForm() {
        const questionSelected = this.getFormInput('qTerm').prop('checked') || this.getFormInput('qDefinition').prop('checked');
        this.modaller.content.find('div[data-bind=questionError]').toggle(!questionSelected);

        const modeSelected = this.getFormInput('mSelect').prop('checked') || this.getFormInput('mWrite').prop('checked');
        this.modaller.content.find('div[data-bind=modeError]').toggle(!modeSelected);

        this.saveButton.prop('disabled', !(questionSelected && modeSelected));
    }

    complete() {
        this.modaller.close();
        if (this.ok) {
            this.config.qTerm = !!this.getFormInput('qTerm').prop('checked');
            this.config.qDefinition = !!this.getFormInput('qDefinition').prop('checked');
            this.config.mSelect = !!this.getFormInput('mSelect').prop('checked');
            this.config.mWrite = !!this.getFormInput('mWrite').prop('checked');
            this.config.rand = !!this.getFormInput('rand').prop('checked');
            this.config.playAudio = !!this.getFormInput('playAudio').prop('checked');
            this.callback(this.config);
        }
    }
}